// extracted by mini-css-extract-plugin
export default {"subheader":"styles_subheader__7n6NB","navigation":"styles_navigation__lMsR9","wrapper":"styles_wrapper__LiUeT","link":"styles_link__PNKJ+","divider":"styles_divider__FzhUx"};